import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { moduleMetadata } from '@storybook/angular';
import { PrintPdfComponent } from '../../../app/content/modules/page/components/product/components/print-pdf/print-pdf.component';
import { WineProduct } from '../../../app/core/interfaces/generated/graphql';
import { withCommonDecorators } from '../../_utils/story-helpers';
import { createDamilanoBarberaProduct } from '../../_mocks/wine-product.mock';

// Prevent the real window.print() from triggering in Storybook
window.print = () => {};

const product = createDamilanoBarberaProduct();

const meta: Meta<PrintPdfComponent> = {
  title: 'Molecules/Product/PrintPdf',
  component: PrintPdfComponent,
  decorators: [
    ...withCommonDecorators(),
    moduleMetadata({ imports: [PrintPdfComponent] }),
  ],
  parameters: {
    docs: {
      description: {
        component: 'Component for displaying product information in a printable PDF format. In Storybook, window.print() is suppressed to only display the rendered component.',
      },
    },
    layout: 'fullscreen',
  },
};

export default meta;
type Story = StoryObj<PrintPdfComponent>;

// The component uses @media screen { :host { display: none; } } since it's print-only.
// We override this in the wrapper so it's visible in Storybook.
const wrapperStyle = 'position: relative; width: 100%; min-height: 100vh;';

export const Default: Story = {
  render: () => ({
    template: `
      <div style="${wrapperStyle}">
        <app-print-pdf [product]="product" [baPercentage]="null"></app-print-pdf>
      </div>
    `,
    props: { product },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-print-pdf')).toBeTruthy();
  },
};

export const WithBaPercentage: Story = {
  render: () => ({
    template: `
      <div style="${wrapperStyle}">
        <app-print-pdf [product]="product" [baPercentage]="'25%'"></app-print-pdf>
      </div>
    `,
    props: { product },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-print-pdf')).toBeTruthy();
  },
};

export const MinimalData: Story = {
  render: () => ({
    template: `
      <div style="${wrapperStyle}">
        <app-print-pdf [product]="minProduct" [baPercentage]="null"></app-print-pdf>
      </div>
    `,
    props: {
      minProduct: {
        id: '2',
        title: 'Simple Wine',
        nodePath: 'vin/simple-wine',
        vismaProductNumber: 'SW001',
        sku: 'SW001',
        productDescription: 'En enkel vin uden mange detaljer.',
        priceTable: {
          id: '2',
          pricings: [{
            amount: 150,
            amountIncVat: 150,
            minQty: 1,
            maxQty: null,
          }]
        },
      } as WineProduct,
    },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-print-pdf')).toBeTruthy();
  },
};
